
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/engine.io-client/index.js
// module id = 294
// module chunks = 0